import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogLadles } from "../../../repositories/CatalogLadleRepository";
import { TableLadle } from "../components/TableLadle";
import { useCatalogLadleContext } from "../context/CatalogLadleContext";

type Props = {};
export const CatalogLadlePage = (props: Props) => {
  const { actions } = useCatalogLadleContext();
  const { ladleId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogLadlesFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogLadles();
    if (resp.ok) {
      const ladles = get(resp, "data.tables[0].rows", []);
      actions.setLadles(ladles);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogLadlesFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Ladles"} />
      <Grid container>
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableLadle
              ladleId={ladleId}
              isLoading={isLoading}
              getCatalogLadlesFromAPI={getCatalogLadlesFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
